import { SelectionModel } from '@angular/cdk/collections';
import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSelectionListChange, MatListModule } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ELIMSProduct } from 'src/app/domain/ELIMS/ELIMS-Product';
import { ProductGroup } from 'src/app/domain/product-group';
import { ELIMSService } from 'src/app/services/ELIMS.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { NotificationManager } from '../notification-manager';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-product-box',
    templateUrl: './product-box.component.html',
    styleUrl: './product-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatChipsModule, MatIconModule, MatButtonModule, PreventDoubleClickDirective, MatListModule]
})
export class ProductBoxComponent implements OnInit, AfterContentInit {

    Model: ProductGroup = new ProductGroup();
    IsCreation: boolean = true;
    keywords: string[] = [];
    formControl = new FormControl(['angular']);
    AvailableElimsProductList: ELIMSProduct[] = []

    constructor(
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<ProductBoxComponent>,
        private configurationService: ConfigurationService,
        private ELIMSService: ELIMSService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.Model = Object.assign({}, data);
            this.IsCreation = false;
        }
    }
    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }

    removeKeyword(keyword: string) {
        const index = this.keywords.indexOf(keyword);
        if (index >= 0) {
            this.keywords.splice(index, 1);
        }
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our keyword
        if (value) {
            this.keywords.push(value);
        }

        // Clear the input value
        event.chipInput!.clear();
    }

    search() {
        this.ELIMSService.getMatriceList(this.keywords).subscribe(x => {
            if (x) {
                this.AvailableElimsProductList = x;
                if (x.length === 0)
                    NotificationManager.handleWarning('Aucun résultat', this.snackBar)
            }
        })
    }

    onSelection(e: MatSelectionListChange, v: SelectionModel<any>) {
        this.Model.ElimsProductList.push(...[e.options[0].value]);
    }

    CanSave() {
        return this.Model.ElimsProductList.length >= 1 && this.Model.Name;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (!this.CanSave())
            return;

        this.dialogRef.close(this.Model);
    }
}
